import React from 'react'

import { Warning as WarningIcon } from '@mui/icons-material'

import { getBattery, getSignalIcon } from '~/src/Device/utils'
import DisconnectedIcon from '~/src/UI/Icons/Disconnected'
import GatewayDownIcon from '~/src/UI/Icons/GatewayDown'
import PuckDisconnectedIcon from '~/src/UI/Icons/PuckDisconnected'

const keyToIcon = {
  GATEWAY_DISCONNECTED: GatewayDownIcon,
  DEVICE_UNPLUGGED: DisconnectedIcon,
  DEVICE_DISCONNECTED: DisconnectedIcon,
  PUCK_DISCONNECTED: PuckDisconnectedIcon,
}
const Component = props => {
  const { annotation: { key, data }, color } = props

  let Icon = WarningIcon

  if (!key && !data) return <Icon color={color} />

  if (key.includes('BATTERY') && data.battery != null) {
    Icon = getBattery(data.battery).Icon
  }

  if (key.includes('SIGNAL') && data.rssi != null) {
    Icon = getSignalIcon(data.rssi).Icon
  }

  if (keyToIcon[key]) {
    Icon = keyToIcon[key]
  }

  return <Icon color={color} />
}

export default Component
